export const ERRP_TYPE_PRE_EXPIRATION_1 = 'PreExpiration1'
export const ERRP_TYPE_PRE_EXPIRATION_2 = 'PreExpiration2'
export const ERRP_TYPE_POST_EXPIRATION = 'PostExpiration1'
export const ERRP_TYPE_VALUES = [ERRP_TYPE_PRE_EXPIRATION_1, ERRP_TYPE_PRE_EXPIRATION_2, ERRP_TYPE_POST_EXPIRATION]
export const ERRP_TYPE_DEFAULT_VALUE = ERRP_TYPE_PRE_EXPIRATION_1
